import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import * as S from './style';
import { Form, Button } from 'reactstrap';
import FlexSelect from 'components/Inputs/FlexSelect';

export const LogoutFormInput = ({
  handleLogout,
  shouldSign = true,
  queues,
  isPaused
}) => {
  const { control, handleSubmit, setValue } = useForm();

  return (
    <S.LogoutContainer>
      <Form onSubmit={handleSubmit(handleLogout)}>
        <div className="d-flex justify-content-between align-items-top">
          {shouldSign ? (
            <></>
          ) : (
            <Controller
              render={(props) => (
                <div style={{ flex: 0.7 }}>
                  <FlexSelect
                    placeholder="Selecione a(s) fila(s)"
                    isClearable={true}
                    dataOptions={queues}
                    isMulti={true}
                    closeMenuOnSelect={false}
                    value={props.value}
                    valueController={setValue}
                    fieldName="queueIds"
                    labelName="name"
                    valueName="id"
                    isDisabled={isPaused}
                    minHeight="1rem"
                  />
                </div>
              )}
              control={control}
              name="queueIds"
              defaultValue=""
            />
          )}

          {shouldSign ? (
            <></>
          ) : (
            <Button
              type="submit"
              disabled={isPaused}
              color="danger"
              size="sm"
              style={{ flex: 0.3, marginLeft: '10px' }}
            >
              Fazer Logout
            </Button>
          )}
        </div>
      </Form>
    </S.LogoutContainer>
  );
};
